import { render, staticRenderFns } from "./documentsUploader.vue?vue&type=template&id=635f19d2"
import script from "./documentsUploader.vue?vue&type=script&lang=js"
export * from "./documentsUploader.vue?vue&type=script&lang=js"
import style0 from "./documentsUploader.vue?vue&type=style&index=0&id=635f19d2&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports